let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4JYZP")).then(() => parcelRequire('feYkj'));